// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveLearningSelectPage_wrapper__1MDl-","buttonWrapper":"ActiveLearningSelectPage_buttonWrapper__MDW_2"};